// Customer testimonials supplied by the client. "(Add_company_Or_Brand_Name)" has been replaced with the brand name.
// Each testimonial uses a service icon instead of a profile photo.
export const TESTIMONIALS = [
  {
    "name": "Rahul Sharma",
    "service": "Website Development",
    "stars": 5,
    "icon": "Globe",
    "text": "Working with Athlevo IT Solution on our website was a positive experience. The team understood our requirements, suggested useful improvements, and focused on creating a professional online presence. Communication was smooth, and the development process helped us organize our business information and services effectively."
  },
  {
    "name": "Amit Verma",
    "service": "E-commerce Website",
    "stars": 5,
    "icon": "ShoppingCart",
    "text": "Athlevo IT Solution helped us plan our e-commerce website with a focus on product presentation and usability. The team discussed our requirements and worked on the important features needed for online shopping. Their approach was professional, and communication throughout the project was helpful."
  },
  {
    "name": "Priya Patel",
    "service": "SEO Services",
    "stars": 5,
    "icon": "Search",
    "text": "We explored SEO services with Athlevo IT Solution to improve our website's search visibility. The team discussed keyword research, technical optimization, and content improvements. Their explanations helped us understand the importance of consistent SEO work and gave us a clearer direction for our digital marketing strategy."
  },
  {
    "name": "Vikas Singh",
    "service": "Digital Marketing",
    "stars": 5,
    "icon": "Megaphone",
    "text": "Our discussions with Athlevo IT Solution about digital marketing covered online promotion, audience targeting, and campaign planning. The team explained different marketing options and helped us consider suitable strategies for our business goals. Their structured approach made the planning process easier to understand."
  },
  {
    "name": "Neha Gupta",
    "service": "Mobile App Development",
    "stars": 5,
    "icon": "Smartphone",
    "text": "Athlevo IT Solution helped us outline our mobile application requirements, including essential features, usability, and technical considerations. The team discussed the development process and possible implementation approaches. This gave us a clearer understanding of the project scope and helped us organize our priorities."
  },
  {
    "name": "Rohit Yadav",
    "service": "Responsive Website Design",
    "stars": 5,
    "icon": "MonitorSmartphone",
    "text": "The website design discussions with Athlevo IT Solution focused on clean layouts, navigation, and mobile responsiveness. The team considered how visitors would access important information across devices. Their practical suggestions helped us understand how to organize the website around our business requirements and audience."
  },
  {
    "name": "Pooja Mishra",
    "service": "Website Redesign",
    "stars": 5,
    "icon": "RefreshCw",
    "text": "We considered redesigning our website with Athlevo IT Solution to improve its overall presentation and usability. Discussions covered page layouts, navigation, content structure, and functionality. The team helped us identify potential improvements and establish a clearer direction for our website redesign project."
  },
  {
    "name": "Ankit Jain",
    "service": "WordPress Development",
    "stars": 5,
    "icon": "LayoutTemplate",
    "text": "Athlevo IT Solution discussed our WordPress website requirements, including page structure, design, and essential functionality. The team explained available options and considered future content management needs. The planning process helped us understand the proposed website solution and identify features relevant to our business."
  },
  {
    "name": "Sneha Joshi",
    "service": "Shopify Store",
    "stars": 5,
    "icon": "Store",
    "text": "We discussed our Shopify store requirements with Athlevo IT Solution, including product pages, navigation, and the shopping experience. The team helped identify important store features and layout considerations. Their guidance provided a useful starting point for planning an online store suited to our business needs."
  },
  {
    "name": "Mohit Sharma",
    "service": "Custom Software",
    "stars": 5,
    "icon": "Code2",
    "text": "Athlevo IT Solution helped us explore a custom software solution for our business requirements. The discussions covered essential features, workflows, and technical considerations. The team explained different implementation options, helping us define the project scope and prioritize the functionality most relevant to our operations."
  },
  {
    "name": "Kavita Rathore",
    "service": "Business Website",
    "stars": 5,
    "icon": "Briefcase",
    "text": "We needed a professional website to present our business services clearly. Athlevo IT Solution discussed our goals, page requirements, and preferred design direction. The planning process helped us organize our content and consider how a well-structured website could communicate our services to potential customers."
  },
  {
    "name": "Deepak Thakur",
    "service": "Website Maintenance",
    "stars": 5,
    "icon": "Wrench",
    "text": "Our website maintenance discussions with Athlevo IT Solution covered updates, performance, security, and routine technical checks. The team explained why ongoing maintenance matters and helped us identify areas requiring attention. Their guidance provided a clearer understanding of the work involved in maintaining a business website."
  },
  {
    "name": "Anjali Dubey",
    "service": "Website Speed Optimization",
    "stars": 5,
    "icon": "Gauge",
    "text": "Athlevo IT Solution helped us review website performance and understand potential speed improvements. The discussion covered page loading, image optimization, and technical considerations. The recommendations provided a starting point for identifying performance issues and planning changes intended to improve the visitor experience."
  },
  {
    "name": "Saurabh Patel",
    "service": "Google Ads",
    "stars": 5,
    "icon": "MousePointerClick",
    "text": "We discussed Google Ads campaign planning with Athlevo IT Solution, focusing on business objectives, audience targeting, and keyword selection. The team explained important campaign considerations and performance monitoring. This helped us better understand the planning required for paid search advertising and online lead generation."
  },
  {
    "name": "Shweta Sharma",
    "service": "Social Media Marketing",
    "stars": 5,
    "icon": "Share2",
    "text": "Athlevo IT Solution helped us explore social media marketing options for our business. Discussions covered content planning, brand communication, audience engagement, and platform selection. The team provided a structured way to think about maintaining a consistent online presence and planning relevant marketing activities."
  },
  {
    "name": "Nitin Chouhan",
    "service": "CRM Integration",
    "stars": 5,
    "icon": "Workflow",
    "text": "We discussed integrating website lead capture with our CRM through Athlevo IT Solution. The requirements included collecting enquiries, organizing lead information, and improving data flow. The discussion helped clarify the integration scope and the importance of a reliable process for managing customer enquiries."
  },
  {
    "name": "Akash Rajput",
    "service": "Web Application Development",
    "stars": 5,
    "icon": "AppWindow",
    "text": "Athlevo IT Solution helped us outline our web application requirements, including user workflows, interface design, and core functionality. The team discussed technical considerations and possible implementation approaches. This gave us a clearer project scope and helped us prioritize features relevant to our intended users."
  },
  {
    "name": "Ritika Agrawal",
    "service": "Affordable IT Solutions",
    "stars": 5,
    "icon": "Wallet",
    "text": "We explored IT solutions with Athlevo IT Solution based on our business needs and available budget. Discussions covered suitable technologies, essential features, and practical implementation choices. Their explanations helped us compare priorities and consider a solution aligned with our requirements without unnecessary complexity."
  },
  {
    "name": "Manish Tiwari",
    "service": "Customer Support",
    "stars": 5,
    "icon": "Headset",
    "text": "During our discussions with Athlevo IT Solution, the team helped clarify our questions and explain available options. Communication focused on understanding requirements and identifying next steps. This approach made it easier to discuss technical matters and consider solutions for our business needs."
  },
  {
    "name": "Komal Verma",
    "service": "Website Security",
    "stars": 5,
    "icon": "ShieldCheck",
    "text": "Athlevo IT Solution helped us understand important website security considerations, including software updates, access controls, and routine checks. The discussion highlighted areas that businesses should review when maintaining an online presence and provided a starting point for planning website security improvements."
  },
  {
    "name": "Harsh Vyas",
    "service": "Landing Page Design",
    "stars": 5,
    "icon": "PanelsTopLeft",
    "text": "We discussed a landing page for our business with Athlevo IT Solution, focusing on page layout, messaging, and the enquiry process. The team considered how visitors would find key information and take action. The planning helped us define the content and features needed for the page."
  },
  {
    "name": "Meena Kumari",
    "service": "Website Content and Structure",
    "stars": 5,
    "icon": "ListTree",
    "text": "Athlevo IT Solution helped us review how our website content could be organized across different pages. Discussions covered navigation, service descriptions, and information hierarchy. This approach helped us think more clearly about presenting our business information and making important details easier for visitors to find."
  },
  {
    "name": "Ravi Kushwaha",
    "service": "Technical Consultation",
    "stars": 5,
    "icon": "MessagesSquare",
    "text": "We consulted Athlevo IT Solution about our technical requirements and possible implementation options. The team discussed project scope, functionality, and technology choices in straightforward terms. The conversation helped us understand the main considerations before deciding on the next steps for our digital project."
  },
  {
    "name": "Pankaj Dhakad",
    "service": "Inventory and POS Software",
    "stars": 5,
    "icon": "ScanBarcode",
    "text": "Athlevo IT Solution helped us outline requirements for a point-of-sale and inventory management solution. Discussions covered product records, stock tracking, sales workflows, and reporting needs. This planning provided a starting point for defining the software features required to support our business operations."
  },
  {
    "name": "Divya Singh",
    "service": "Complete Digital Solutions",
    "stars": 5,
    "icon": "Layers",
    "text": "We explored several digital requirements with Athlevo IT Solution, including website development, online visibility, and business technology. The team helped separate our needs into manageable areas and discuss possible priorities. This gave us a clearer overview of the digital improvements to consider as our business develops."
  }
];
